// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 2718) return "static/chunks/2718-bfa7a5415942ce5b.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1160":"a77c0a214e6cf3bb","2047":"ad55ecc548bf5e64","2207":"f3572c1831fc3b42","3509":"63f8f2bc99eb2ad0","4653":"f0245ef7b07f86db","6879":"65ea2ec11f019e7e"}[chunkId] + ".js";
};